import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../../../common_components/common_btn/purple_btn/Purple_Btn";
import Purple_border_btn from "../../../../common_components/common_btn/purple_border_btn/Purple_border_btn";

import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useFieldArray, useForm } from "react-hook-form";
import { Context } from "../../../../../utils/context";
import { getGiftWrapPrice } from "../../../../../utils/apis/addToCart/addToCart";
import { getGiftWrapPriceLuxuxry } from "../../../../../utils/luxuryapis/addToCart/addToCart";

function Step2_FlatRate({
  goToStep,
  cartData,
  giftData,
  setGiftData,
  hasGiftItems,
  setHasGiftItems,
  giftEntireOrder,
  setGiftEntireOrder,
  giftIndividualItems,
  setGiftIndividualItems,
  user,
}) {
  const { IMG_URL } = useContext(Context);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
    watch,
    setValue,
  } = useForm();

  const { fields } = useFieldArray({
    control,
    name: "gifts",
  });
  const watchGifts = watch("gifts");
  const [giftError, setGiftError] = useState("");
  const [giftSelectError, setGiftSelectError] = useState("");
  const onSubmit = async (data) => {
    if (giftIndividualItems) {
      const hasSelectedGift = data.gifts?.some((item) => item.isGift);
      if (!hasSelectedGift) {
        setGiftSelectError("Please select at least one item for gift wrap");
        return;
      }
    }
    setGiftSelectError("");
    setGiftData(data);
    goToStep(3);
  };

  const handleContinue = () => {
    if (hasGiftItems) {
      if (!giftIndividualItems || !giftEntireOrder) {
        setGiftError("Please select gift wrap option");
        return;
      }
    }
    setGiftError("");
    goToStep(3);
  };

  useEffect(() => {
    if (giftData) {
      reset(giftData);
    } else {
      if (cartData?.data?.length) {
        const defaultGiftData = cartData.data.map((item) => ({
          cart_item_id: item.id,
          quantity: item?.quantity,
          price: item?.product_quantity?.price,
          isGift: false,
          from: "",
          to: "",
          message: "",
        }));

        reset({ gifts: defaultGiftData });
      }
    }
  }, [cartData, reset, giftData]);

  const [appSetup, setAppSetup] = useState([]);
  const GetAppSetup = async () => {
    const res = await getGiftWrapPriceLuxuxry();
    if (res?.success) {
      setAppSetup(res?.data);
    } else {
      console.error("Error fetching data:", res?.error);
    }
  };

  useEffect(() => {
    GetAppSetup();
  }, []);

  const calculateGiftPrice = (val) => {
    console.log(val, "val val val");

    // if (!val?.s_price || !val?.quantity) return 0;
    const matchedGift = appSetup.find(
      (item) =>
        Number(val.price) >= Number(item.start_price) &&
        Number(val.price) <= Number(item.end_price),
    );

    console.log(matchedGift, "matchedGift matchedGift");

    const pricePerUnit = matchedGift ? Number(matchedGift.price || 0) : 0;
    const totalPrice = pricePerUnit * Number(val.quantity);

    return totalPrice;
  };
  return (
    <>
      <div className="content_box_holder mt-3">
        <div className="heading_strip_holder">
          <div className="content_strip_holder">
            <div>
              <h1>Account</h1>
            </div>
          </div>
          <hr />
        </div>

        <div className="content_strip_holder">
          <p>{user?.email}</p>
          {/* <FontAwesomeIcon icon={faPenToSquare} /> */}
        </div>
      </div>
      <Form>
        <div className="content_box_holder mt-3">
          <div className="heading_strip_holder">
            <div className="content_strip_holder">
              {/* <div>
              <h1>Flat Rate : ₹ 300</h1>
            </div> */}
            </div>
            <hr />
          </div>

          <Form.Group controlId="giftMain" className="mb-5">
            <Form.Check
              type="checkbox"
              label="DO YOU HAVE ANY GIFT ITEMS IN YOUR ORDER?"
              checked={hasGiftItems}
              onChange={(e) => {
                const checked = e.target.checked;
                setHasGiftItems(checked);

                if (!checked) {
                  setGiftEntireOrder(false);
                  setGiftIndividualItems(false);
                }
              }}
            />
          </Form.Group>

          {hasGiftItems && (
            <>
              <ul className="list_holder">
                {(!giftIndividualItems || giftEntireOrder) && (
                  <li>
                    <Form.Group controlId="giftEntireOrder" className="mb-3">
                      <Form.Label className="check_box_heading">
                        GIFT OPTIONS FOR THE ENTIRE ORDER
                      </Form.Label>

                      <Form.Check
                        type="checkbox"
                        label="Add Gift Options for the Entire Order"
                        checked={giftEntireOrder}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setGiftEntireOrder(checked);
                          if (checked) setGiftIndividualItems(false);
                          setGiftError("");
                        }}
                      />
                    </Form.Group>
                  </li>
                )}

                {(!giftEntireOrder || giftIndividualItems) && (
                  <li>
                    <Form.Group
                      controlId="giftIndividualItems"
                      className="mb-3"
                    >
                      <Form.Label className="check_box_heading">
                        GIFT OPTIONS FOR INDIVIDUAL ITEMS
                      </Form.Label>

                      <Form.Check
                        type="checkbox"
                        label="Add Gift Options for Individual Items"
                        checked={giftIndividualItems}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setGiftIndividualItems(checked);
                          if (checked) setGiftEntireOrder(false);
                          setGiftError("");
                        }}
                      />
                    </Form.Group>
                  </li>
                )}
              </ul>

              {giftEntireOrder && (
                <div className="row">
                  <div>Flat Rate : ₹ {cartData?.giftprice}</div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <Form.Label>From</Form.Label>
                      <Form.Control
                        type="text"
                        name="from"
                        placeholder="Enter from"
                        {...register("from", {
                          required: "from required",
                        })}
                      />
                      {errors.from && (
                        <div className="error_text_holder">
                          <p>
                            <FontAwesomeIcon
                              icon={faCircleInfo}
                              className="me-2"
                            />
                            {errors.from.message}
                          </p>
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <Form.Label>To</Form.Label>
                      <Form.Control
                        type="text"
                        name="to"
                        placeholder="Enter to"
                        {...register("to", {
                          required: "to  required",
                        })}
                      />
                      {errors.to && (
                        <div className="error_text_holder">
                          <p>
                            <FontAwesomeIcon
                              icon={faCircleInfo}
                              className="me-2"
                            />
                            {errors.to.message}
                          </p>
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-md-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Message*</Form.Label>
                      <Form.Control
                        type="text"
                        name="message"
                        placeholder="Enter message"
                        {...register("message", {
                          required: "message required",
                        })}
                      />
                      {errors.message && (
                        <div className="error_text_holder">
                          <p>
                            <FontAwesomeIcon
                              icon={faCircleInfo}
                              className="me-2"
                            />
                            {errors.message.message}
                          </p>
                        </div>
                      )}
                    </Form.Group>
                  </div>
                </div>
              )}

              {giftIndividualItems && (
                <>
                  {fields.map((field, index) => {
                    const item = cartData?.data[index];

                    return (
                      <div key={field.id}>
                        <div>Flat Rate : ₹ {calculateGiftPrice(field)}</div>
                        {giftSelectError && (
                          <p style={{ color: "red", marginTop: "10px" }}>
                            {giftSelectError}
                          </p>
                        )}

                        <div className="row">
                          <div className="col-md-12">
                            <Form.Check
                              type="checkbox"
                              label="Select for Gift Wrap"
                              {...register(`gifts.${index}.isGift`)}
                            />
                          </div>

                          <div className="col-md-12">
                            <div className="product_text_holder">
                              <div className="img_holder">
                                <img
                                  src={IMG_URL + item?.product?.image1}
                                  alt="product"
                                  className="product_img"
                                />
                              </div>
                              <h1>{item?.product?.name}</h1>
                            </div>
                          </div>

                          {watchGifts?.[index]?.isGift && (
                            <>
                              <div className="col-md-6">
                                <Form.Group className="mb-3">
                                  <Form.Label>From</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="From"
                                    {...register(`gifts.${index}.from`, {
                                      required: "From is required",
                                    })}
                                  />

                                  {errors?.gifts?.[index]?.from && (
                                    <div className="error_text_holder">
                                      <p style={{ color: "red" }}>
                                        <FontAwesomeIcon
                                          icon={faCircleInfo}
                                          className="me-2"
                                        />
                                        {errors.gifts[index].from.message}
                                      </p>
                                    </div>
                                  )}
                                </Form.Group>
                              </div>

                              <div className="col-md-6">
                                <Form.Group className="mb-3">
                                  <Form.Label>To</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="To"
                                    {...register(`gifts.${index}.to`, {
                                      required: "To is required",
                                    })}
                                  />

                                  {errors?.gifts?.[index]?.to && (
                                    <div className="error_text_holder">
                                      <p style={{ color: "red" }}>
                                        <FontAwesomeIcon
                                          icon={faCircleInfo}
                                          className="me-2"
                                        />
                                        {errors.gifts[index].to.message}
                                      </p>
                                    </div>
                                  )}
                                </Form.Group>
                              </div>

                              <div className="col-md-12">
                                <Form.Group className="mb-3">
                                  <Form.Label>Message</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Max. 50 Characters"
                                    {...register(`gifts.${index}.message`, {
                                      required: "Message is required",
                                      maxLength: {
                                        value: 50,
                                        message: "Max 50 characters allowed",
                                      },
                                    })}
                                  />

                                  {errors?.gifts?.[index]?.message && (
                                    <div className="error_text_holder">
                                      <p style={{ color: "red" }}>
                                        <FontAwesomeIcon
                                          icon={faCircleInfo}
                                          className="me-2"
                                        />
                                        {errors.gifts[index].message.message}
                                      </p>
                                    </div>
                                  )}
                                </Form.Group>
                              </div>
                            </>
                          )}
                        </div>

                        <hr />
                      </div>
                    );
                  })}
                </>
              )}

              {/* {giftIndividualItems && (
              <>
                {cartData?.data?.map((item) => (
                  <div key={item}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="product_text_holder">
                          <div>
                            <div className="img_holder">
                              <img
                                src={IMG_URL+item?.product?.image1}
                                alt="product"
                                className="product_img"
                              />
                            </div>
                          </div>
                          <h1>{item?.product?.name}</h1>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <Form.Label>From</Form.Label>
                          <Form.Control type="text" placeholder="From" />
                          <div className="error_text_holder">
                            <p>
                              <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="me-2"
                              />
                              Required Information
                            </p>
                          </div>
                        </Form.Group>
                      </div>

                      <div className="col-md-6">
                        <Form.Group className="mb-3">
                          <Form.Label>To</Form.Label>
                          <Form.Control type="text" placeholder="To" />
                          <div className="error_text_holder">
                            <p>
                              <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="me-2"
                              />
                              Required Information
                            </p>
                          </div>
                        </Form.Group>
                      </div>

                      <div className="col-md-12">
                        <Form.Group className="mb-3">
                          <Form.Label>Message*</Form.Label>
                          <Form.Control
                            type="text"
                            as={"textarea"}
                            rows={3}
                            placeholder="Max. 50 Characters"
                          />
                          <div className="error_text_holder">
                            <p>
                              <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="me-2"
                              />
                              Required Information
                            </p>
                          </div>
                        </Form.Group>
                      </div>
                    </div>

                    {item === 1 && <hr />}
                  </div>
                ))}
              </>
            )} */}
            </>
          )}
          {giftError && (
            <p style={{ color: "red", marginTop: "8px" }}>{giftError}</p>
          )}
          <div className="btn_holder">
            <div onClick={() => goToStep(1)}>
              <Purple_border_btn btnText="Back" />
            </div>

            {hasGiftItems && (giftEntireOrder || giftIndividualItems) ? (
              <div>
                <Purple_Btn
                  btnText="Continue"
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            ) : (
              <div onClick={() => handleContinue()}>
                <Purple_Btn btnText="Continue" />
              </div>
            )}
          </div>
        </div>
      </Form>
    </>
  );
}

export default Step2_FlatRate;
